import DrawTool from "../draw/DrawTool";
import MathTool from "../math/MathTool";

export class PlainColorFill{
    constructor( color, blur=0, offsetX=0, offsetY=0 ){
        this.type="plainColorFill";
        this.color = color;
        this.blur = blur;
        this.offsetX = offsetX;
        this.offsetY = offsetY;
    }
    paint(shape){
        p5App.push();

        // Set color and effects
        p5App.fill(this.color);
        if( this.blur>0){
            let ctx = p5App.drawingContext;
            ctx.filter = 'blur('+this.blur+'px)';
        }

        // Draw shape
        switch( shape.type ){
            case "RECT":
                p5App.rect( shape.x+this.offsetX, shape.y+this.offsetY, shape.width, shape.height);
                break;

            case "CIRCLE":
                p5App.circle( shape.x, shape.y, shape.radius*2);
                break;
        }

        p5App.pop();
    }
}
export class PlainColorStroke{
    constructor( color, weight, join, cap,  ){
        this.type="plainColorStroke";
        this.color = color;
        this.value = color;
        this.weight = weight;
        this.join = join;
        this.cap = cap;
    }
}

export class LinearGradientFillMaterial{
    constructor( colors, p0, p1 ){
        this.type="linearGradientFill";
        this.colors = colors;
        this.p0 = p0;
        this.p1 = p1;
        this.gradient = DrawTool.setLinearGradient( {x:p0.x, y:p0.y}, {x:p1.x, y:p1.y}, colors );
        this.value = this.gradient;
    }
}
export class SpaghettiMaterial{
    constructor( colors ){
        this.type="spaghetti";
        this.colors = colors;
        this.value = this.colors;
    }
}
export class SprinkleMaterial{
    constructor( colors, minRadius, maxRadius, numPoints ){
        this.type="sprinkle";
        this.colors = colors;
        this.value = this.colors;
        this.minRadius = minRadius;
        this.maxRadius = maxRadius;
        this.numPoints = numPoints;
    }
}

export class GlyphMaterial{
    constructor( glyphClass, colors, colorProbabilities, minRadius, maxRadius, density ){
        this.type="glyph";
        this.glyphClass = glyphClass;
        this.colors = colors;
        this.colorProbabilities = colorProbabilities;
        this.minRadius = minRadius;
        this.maxRadius = maxRadius;
        this.density = density;
    }

    paint(shape){        
        let glyphLocations = shape.getSampledPoints(this.density );
        for (let i = 0; i < glyphLocations.length; i++) {
            let p = glyphLocations[i];
            let glyphRadius = MathTool.randomInRange(this.maxRadius, this.minRadius, );            
            let glyph = new this.glyphClass( this, glyphRadius*MathTool.random()*3, p.x, p.y, this.colors[0] );            
        }                             
    }
}

export class OffsetMaterial{
    constructor( color, radius, gap ){
        this.type="offset";
        this.color = color;
        this.radius = radius;
        this.gap = gap;
    }
}